<template>
  <Card class="trade-order">
    <template slot="header">
      <div class="header flex align-center">
        <a class="pointer title mar-r5"> <span>商品设置</span> </a>
        <div class="pointer flex items-center" v-if="!isClick">
          <el-tooltip placement="bottom" effect="dark" :content="tooltip">
            <i class="el-icon-warning-outline gray6 f18 mar5-l"></i>
          </el-tooltip>
        </div>
      </div>
    </template>
    <div class="items h140" v-loading="loading">
      <a class="gray6 pointer item" @click="$openHome(`${origin.VUE_APP_APP}mj/toGoodsMJ.do?appid=1&tag=5`, '在售商品-商品管理', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ shopGoodsNum.status5 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>在售商品</span>
      </a>
      <a class="gray6 pointer item" @click="$openHome(`${origin.VUE_APP_APP}mj/toGoodsMJ.do?appid=1&tag=6`, '已下架商品-商品管理', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ shopGoodsNum.status6 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>已下架商品</span>
      </a>
      <a class="gray6 item">
        <span class="num" v-if="salesAuthority && shopId">{{ shopGoodsNum.promotionGoodsNum || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>促销中商品</span>
      </a>
      <a class="gray6 pointer item" @click="$openHome(`${origin.VUE_APP_APP}mj/toGoodsMJ.do?appid=1&tag=2`, '审核中商品-商品管理', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ shopGoodsNum.status2 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>审核中商品</span>
      </a>
      <a class="gray6 pointer item" @click="$openHome(`${origin.VUE_APP_APP}mj/toGoodsMJ.do?appid=1&tag=3`, '驳回商品-商品管理', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ shopGoodsNum.status3 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>驳回商品</span>
      </a>
      <a class="gray6 item">
        <span class="num" v-if="salesAuthority && shopId">{{ shopGoodsNum.status8 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>强制下架商品</span>
      </a>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "../../index.scss";
</style>

<script>
import { mapState } from "vuex";
import Card from "@/components/Card";

export default {
  components: {
    Card,
  },

  computed: mapState({
    defaultShop: (state) => state.app.defaultShop,
    salesAuthority: (state) => state.app.salesAuthority,
  }),

  data() {
    return {
      loading: true,
      tooltip: "抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限。",
      origin: process.env,
      shopGoodsNum: {},
      shopId: "",
      isClick: true,
    };
  },

  mounted() {
    // 查询店铺商品每个状态的数量
    if (!this.salesAuthority) {
      this.isClick = false;
      this.loading = false;
      return;
    }
    const { shopIdStr, audit } = this.defaultShop;
    if (!shopIdStr || audit !== 1) {
      this.tooltip = "抱歉，您暂未开店或店铺正在审核中,请先开店或等待店铺审成功后再试。";
      this.isClick = false;
      this.loading = false;
      return;
    }
    this.shopId = shopIdStr;
    this.$store.dispatch("trade/shopGoodsNum", { shop_id: shopIdStr }).then((data) => {
      this.loading = false;
      this.shopGoodsNum = data;
    });
  },
};
</script>
